import MoreIcon from "../ui/icons/MoreIcon";
import { Text } from "../ui/text";
import DeleteIcon from "../ui/icons/DeleteIcon";
import ShareIcon from "../ui/icons/ShareIcon";
import RenameIcon from "../ui/icons/RenameIcon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

interface Props {
  onShareClick: () => void;
  onRenameClick: () => void;
  onDeleteClick: () => void;
}

const ChatMoreMenu = ({
  onShareClick,
  onRenameClick,
  onDeleteClick,
}: Props) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="w-[40px] h-[40px] flex justify-center items-center">
          <MoreIcon />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="right"
        align="start"
        className="w-[140px] p-1 flex flex-col gap-[2px]"
      >
        <DropdownMenuItem className="flex items-center" onClick={onShareClick}>
          <div className="w-[40px] h-[40px] flex justify-center items-center">
            <ShareIcon color="#808080" />
          </div>
          <Text variant={"label-lg"} className="text-grey-20">
            Share
          </Text>
        </DropdownMenuItem>
        <DropdownMenuItem className="flex items-center" onClick={onRenameClick}>
          <div className="w-[40px] h-[40px] flex justify-center items-center">
            <RenameIcon color="#808080" />
          </div>
          <Text variant={"label-lg"} className="text-grey-20">
            Rename
          </Text>
        </DropdownMenuItem>
        <DropdownMenuItem className="flex items-center" onClick={onDeleteClick}>
          <div className="w-[40px] h-[40px] flex justify-center items-center">
            <DeleteIcon color="#FF6068" />
          </div>
          <Text variant={"label-lg"} className="text-red-20">
            Delete
          </Text>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ChatMoreMenu;
